export default __webpack_public_path__ + "static/media/6.ce170c13.png";